import { Component, Injector } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../services/modal.service';

@Component({
	standalone: true,
	templateUrl: './base.component.html'
})
export class BaseComponent {
	private _modalService: ModalService;

	constructor(private injector: Injector) {}
	get modalService(): ModalService {
		if (!this._modalService) {
			this._modalService = this.injector.get(ModalService);
		}
		return this._modalService;
	}

	openModal(content: any, options?: NgbModalOptions) {
		this.modalService.open(content, options);
	}

	closeModal() {
		this.modalService.dismissAll();
	}
}
